<template>
  <span class="mm-infotip relative inline-flex items-center justify-center align-middle select-none"
        :class="wrapperClass"
        role="button"
        :aria-label="ariaLabel"
        :aria-expanded="isOpen ? 'true' : 'false'"
        tabindex="0"
        @click.stop="toggle"
        @keydown.enter.prevent="toggle"
        @keydown.space.prevent="toggle"
        @keydown.escape.stop.prevent="close"
        @blur="onBlur">
    <span class="mm-infotip__icon">i</span>
    <span class="mm-infotip__bubble" :class="{ 'is-open': isOpen }" role="tooltip">
      {{ text }}
    </span>
  </span>
</template>

<script>
import { t } from '../i18n'
export default {
  name: 'MmInfoTip',
  props: {
    text: { type: String, required: true },
    size: { type: String, default: 'md' }, // sm, md
    ariaLabel: { type: String, default: () => t('aria.info') }
  },
  data(){
    return { isOpen: false }
  },
  computed: {
    wrapperClass(){
      return this.size === 'sm' ? 'w-4 h-4' : 'w-5 h-5'
    }
  },
  methods: {
    toggle(){ this.isOpen = !this.isOpen },
    close(){ this.isOpen = false },
    onBlur(e){
      // delay to allow click on bubble if needed, then close
      setTimeout(()=>{ this.isOpen = false }, 100)
    }
  }
}
</script>

<style scoped>
.mm-infotip{ border-radius: 9999px; background:#d8d1c6; color:#333; font-weight:700; font-size:11px; line-height:1; cursor: pointer; }
.mm-infotip__icon{ display:inline-flex; align-items:center; justify-content:center; width:100%; height:100%; }
.mm-infotip__bubble{ position:absolute; z-index:50; top:100%; left:50%; transform: translate(-50%, 6px); white-space: normal; width: max-content; min-width: 160px; max-width: min(90vw, 320px); background:#111; color:#fff; padding:8px 10px; font-size:12px; border-radius:4px; line-height:1.35; box-shadow: 0 6px 18px rgba(0,0,0,0.2); opacity:0; pointer-events:none; transition: opacity .15s ease, transform .15s ease; }
.mm-infotip__bubble::after{ content:''; position:absolute; top:-6px; left:50%; transform: translateX(-50%); border-width:6px; border-style:solid; border-color: transparent transparent #111 transparent; }

/* Show on hover or focus */
.mm-infotip:hover .mm-infotip__bubble,
.mm-infotip:focus .mm-infotip__bubble,
.mm-infotip:focus-within .mm-infotip__bubble,
.mm-infotip__bubble.is-open{ opacity:1; transform: translate(-50%, 10px); pointer-events:auto; }
</style>
